// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ow-0";